module.exports = __webpack_public_path__ + "img/katasterInfo_o.6204e770.png";